import { Navigate } from 'react-router-dom'
import { StateBlock } from '@w7/ui'
import { useSession } from '@/app/queries'
import { canAccessLogPage, type LogPageId } from './access'

/**
 * Menu and route share one gate. A hand-typed URL must not show a page the
 * rail hid for this role.
 */
export function LogAccessGate({
  pageId,
  children,
}: {
  pageId: LogPageId
  children: React.ReactNode
}) {
  const { data: session, isLoading } = useSession()

  if (isLoading) {
    return (
      <StateBlock icon="activity" title="Loading…">
        Checking whether this log is available for your seat.
      </StateBlock>
    )
  }

  if (!canAccessLogPage(session?.account.role, pageId)) {
    return <Navigate to="/overview" replace />
  }

  return <>{children}</>
}
